// Controlled SW-update (update-on-reload). SPEC pwa-shell §4.3 / §4.9 (инв.2 «без сюрпризов»).
//
// Проблема: авто-skipWaiting+claim переключают код «на лету» → активная вкладка ловит чужие
// чанки → белый экран. Решение: новый SW ждёт в `waiting`; переключение — ТОЛЬКО по явному
// applyUpdate() пользователя → postMessage(SKIP_WAITING) → SW.skipWaiting() → controllerchange →
// РОВНО ОДИН reload (guard от двойной перезагрузки). Оконная логика; SW-сторона — message-обработчик
// в sw.ts. Зависимости инъецируются — тестируется в Node.
/** Тип сообщения окно→SW для применения ожидающего обновления (§4.3 п.3). */
export const SKIP_WAITING_MESSAGE = { type: 'SKIP_WAITING' };
/**
 * Контроллер обновления в окне. Держит флаг готовности и guard одного reload.
 * Реальные слушатели (updatefound/statechange/controllerchange) подключает PwaProvider и
 * прокидывает события сюда — контроллер чистый и тестируемый.
 */
export class UpdateController {
    onUpdateReady;
    waiting = null;
    reloaded = false;
    /** Колбэк наружу: «обновление готово» (app-ui покажет ненавязчивый тост). */
    constructor(onUpdateReady = () => { }) {
        this.onUpdateReady = onUpdateReady;
    }
    /**
     * Вызывается, когда новый SW встал в `waiting` при наличии активного контроллера (§4.3 п.2).
     * На первом визите (reg.active===null) НЕ сигналим — обновлять нечего (§4.3 п.5).
     */
    onWaiting(reg) {
        if (reg.waiting === null)
            return;
        if (reg.active === null) {
            // Первый визит: новый SW сам claim'нется (sw.ts), «текущей сессии» нет — тоста не надо.
            return;
        }
        this.waiting = reg.waiting;
        this.onUpdateReady();
    }
    /** Есть ли готовое к применению обновление (для флага updateReady в окне). */
    get updateReady() {
        return this.waiting !== null;
    }
    /**
     * Применяет ожидающее обновление (§4.3 п.3): шлёт waiting-воркеру SKIP_WAITING. Дальше SW
     * вызовет skipWaiting() → сменится контроллер → onControllerChange сделает reload. No-op, если
     * нечего применять.
     */
    applyUpdate() {
        if (this.waiting === null)
            return;
        this.waiting.postMessage(SKIP_WAITING_MESSAGE);
    }
    /**
     * Вызывается на navigator.serviceWorker.controllerchange (§4.3 п.4). Перезагружает страницу
     * РОВНО ОДИН раз (guard reloaded) — иначе controllerchange может сработать дважды и зациклить
     * reload. Возвращает true, если reload был инициирован (для теста guard'а).
     */
    onControllerChange(reload) {
        if (this.reloaded)
            return false;
        this.reloaded = true;
        reload();
        return true;
    }
}
//# sourceMappingURL=update.js.map